export const placeholderCatalog = [
  {
    category: "Contract",
    placeholders: [
      { key: "TENANT_LEGAL_NAME", label: "Bedrijfsnaam" },
      { key: "TENANT_VAT", label: "BTW-nummer bedrijf" },
      { key: "TENANT_ADDRESS", label: "Adres bedrijf" },
      { key: "TENANT_EMAIL", label: "Email bedrijf" },
      { key: "TENANT_PHONE", label: "Telefoonnummer bedrijf" },
      { key: "DATE_TODAY", label: "Datum vandaag" },
    ],
  },
  {
    category: "Eigenaar",
    placeholders: [
      { key: "CUSTOMER_NAME", label: "Naam klant" },
      { key: "CUSTOMER_ADDRESS", label: "Adres klant" },
      { key: "CUSTOMER_EMAIL", label: "Email klant" },
      { key: "CUSTOMER_PHONE", label: "Telefoonnummer klant" },
    ],
  },
  {
    category: "Reservatie",
    placeholders: [
      { key: "RESERVATION_NUMBER", label: "Reservatienummer" },
      { key: "CHECK_IN_DATE", label: "Check-in datum" },
      { key: "CHECK_IN_HOUR", label: "Check-in uur" },
      { key: "CHECK_OUT_DATE", label: "Check-out datum" },
      { key: "CHECK_OUT_HOUR", label: "Check-out uur" },
      { key: "RESERVATION_STAY", label: "Verblijfstype" },
      { key: "ANIMAL_NAMES_IN_RESERVATION", label: "Namen dieren" },
    ],
  },
  {
    category: "Financieel",
    placeholders: [
      { key: "RESERVATION_TOTAL_AMOUNT", label: "Totaalbedrag" },
      { key: "RESERVATION_ADVANCE", label: "Voorschot" },
      { key: "RESERVATION_REMAINING_AMOUNT", label: "Resterend bedrag" },
    ],
  },
  {
    category: "Diergegevens",
    placeholders: [
      { key: "ANIMAL_TYPE", label: "Ras/Type" },
      { key: "ANIMAL_BIRTHDATE", label: "Geboortedatum" },
      { key: "ANIMAL_SEX", label: "Geslacht" },
      { key: "ANIMAL_CHIP_NUMBER", label: "Chipnummer" },
      { key: "ANIMAL_COLOR", label: "Kleur" },
    ],
  },
  {
    category: "Medisch & Gedrag",
    placeholders: [
      { key: "ANIMAL_DIEET", label: "Dieet" },
      { key: "ANIMAL_MEDICATION", label: "Medicatie" },
      { key: "ANIMAL_CONTACT_OTHERS", label: "Contact met anderen" },
      { key: "ANIMAL_BEHAVIOR_HOME", label: "Gedrag thuis" },
      { key: "ANIMAL_BEHAVIOR_OTHER_ANIMALS", label: "Gedrag met andere dieren" },
    ],
  },
  {
    category: "Dierenarts",
    placeholders: [
      { key: "ANIMAL_VET_NAME", label: "Naam dierenarts" },
      { key: "ANIMAL_VET_LEGA_NAME", label: "Praktijknaam" },
      { key: "ANIMAL_VET_ADRESS", label: "Adres dierenarts" },
      { key: "ANIMAL_VET_PHONE", label: "Telefoon dierenarts" },
    ],
  },
  {
    category: "Noodcontact",
    placeholders: [
      { key: "EMERGENCY_CONTACT_NAME", label: "Naam noodcontact" },
      { key: "EMERGENCY_ADRESS", label: "Adres noodcontact" },
      { key: "EMERGENCY_PHONE", label: "Telefoon noodcontact" },
    ],
  },
];
